import { Component, OnInit } from '@angular/core';
import { SupportService } from 'src/app/rest_services/msHelpServices/support.service';
import { SurveyService } from 'src/app/rest_services/msSurveyServices/survey.service';
import { UserService } from 'src/app/rest_services/user.service';

@Component({
  selector: 'app-support-survey',
  templateUrl: './support-survey.component.html',
  styleUrls: ['./support-survey.component.css']
})
export class SupportSurveyComponent implements OnInit {
  ticketsLoading: boolean = true;
  alltickets: any[] = [];

  constructor(
    private userService: UserService,
    private supportService: SupportService,
    private msSurvey: SurveyService
  ) { }

  ngOnInit(): void {
    this.loadTickets();
  }

  loadTickets() {
    this.ticketsLoading = true;
    this.msSurvey.getSupportSurvey().subscribe(
      (data: any) => {
        if (data.status === '200') {
          this.alltickets = data.supportSurvey;
          this.alltickets.forEach(ticket => {
            this.loadTicketDetails(ticket.ticket_uuid, ticket);
          });
        } else {
          this.initializeDatatable();
          console.error('Failed to load tickets');
        }
      },
      (error: any) => {
        console.error('There was an error!', error);
        this.ticketsLoading = false;
      }
    );
  }

  loadTicketDetails(ticketId: string, ticket: any) {
    this.supportService.getRequestDetail(ticketId).subscribe(
      (response: any) => {
        if (response.status === '200') {
          Object.assign(ticket, response.ticket);
          this.fetchCreator(ticket);
        } else {
          console.error('Failed to load ticket details');
        }
      },
      (error: any) => {
        console.error('There was an error!', error);
      }
    );
  }

  fetchCreator(ticket: any) {
    const userId = ticket.createdBy;
    this.userService.getUserFilteredData(userId, ['fullName', 'company']).subscribe(
      (userData: any) => {
        if (userData) {
          ticket.creator = userData.connected_user.user_fullname;
          ticket.organisation = userData.connected_user.company_name;
          this.ticketsLoading = false;
          this.initializeDatatable();
        }
      },
      (error: any) => {
        console.error('Error fetching user data:', error);
        // Handle error if needed
      }
    );
  }

  ticket: any;
  surveyResultLoading: boolean = true;
  selectedTicket(ticket: any) {
    this.ticket = ticket;
    ($('#surveyResult') as any).modal('show');
    this.surveyResultLoading=true;
    const surveyContainer = document.getElementById('surveyQuestions');
    if(surveyContainer)surveyContainer.innerHTML = '';

    this.getCustomerResponses(this.ticket.ticket_uuid);
  }

  generateSurvey(survey_answers :any) {
    var surveyContainer = document.getElementById('surveyQuestions');
    var questionTypeOrder: { [key: string]: number } = { 'st': 1, 'ch': 2, 'fr': 3 };

    // Sort the survey answers based on the custom order
    survey_answers.sort(function (a: any, b: any) {
        return questionTypeOrder[a.qst_type] - questionTypeOrder[b.qst_type];
    });

    survey_answers.forEach(function (answer:any) {
      var questionDiv = document.createElement('div');
      questionDiv.className = "row d-flex justify-content-center mb-5 mt-5";
      var questionContent = `
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              ${answer.question}
          </div>
      `;
      var responseContent;
      if (answer.qst_type === 'ch') {
          responseContent = `
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="display: flex; justify-content: space-evenly">
                  <div>
                      <label class="new-control new-checkbox new-checkbox-rounded checkbox-success">
                          <input type="checkbox" disabled ${answer.response === 'oui' ? 'checked' : ''} class="new-control-input">
                          <span class="new-control-indicator"></span>Oui 
                      </label>
                  </div>
                  <div>
                      <label class="new-control new-checkbox new-checkbox-rounded checkbox-success">
                          <input type="checkbox" disabled ${answer.response === 'non' ? 'checked' : ''} class="new-control-input">
                          <span class="new-control-indicator"></span>Non 
                      </label>
                  </div>
              </div>
          `;
      } else if (answer.qst_type === 'st') {
          var filledStars = parseInt(answer.response);
          var emptyStars = 5 - filledStars;
          responseContent = `
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="display: block;">
                  <ul>
                      ${Array.from({ length: filledStars }, (_, i) => `
                          <li class="col-2 step-item-line mr-1 list-inline-item">
                              <i class="flaticon-star-fill"></i>
                          </li>
                      `).join('')}
                      ${Array.from({ length: emptyStars }, (_, i) => `
                          <li class="col-2 step-item-line mr-1 list-inline-item">
                              <i class="flaticon-star-outline"></i>
                          </li>
                      `).join('')}
                  </ul>
              </div>
          `;
        } else if (answer.qst_type === 'fr') {
          responseContent = `
              <div class="row col-lg-6 col-md-6 col-sm-12 col-xs-12" style="display: block;">
                  <textarea style="height: 120px;" readonly class="form-control pl-3 pr-3" rows="2">${answer.response}</textarea>
              </div>
          `;
      }
      questionDiv.innerHTML = questionContent + responseContent;
      surveyContainer?.appendChild(questionDiv);
    });
  }
  customer_fullName:string = '';

  getCustomerResponses(visitUuid: any){
    this.msSurvey.getCustomerResponses(visitUuid);
    this.msSurvey.customerResponsesSubject.subscribe(
      ( data: any ) => {
        if(data.status== '200'){
          const survey_answers = data.survey_answers;
          this.generateSurvey(survey_answers);
          this.surveyResultLoading=false;
        }
      },
    )    
  }

  initializeDatatable() {
    setTimeout(() => {
      (<any>$("#alter_pagination")).DataTable({
        "destroy": true,
        "pagingType": "full_numbers",
        "scrollX": '400px',
        "scrollCollapse": true,
        aaSorting: false, // Order by the third column (Date de création) in descending order
        "iDisplayLength": 25,
        // columnDefs: [ { type: 'string', 'targets': [0], "orderable": true } ],
        "language": {
          "sProcessing": "Traitement en cours ...",
          "sLengthMenu": "Afficher _MENU_ lignes",
          "sZeroRecords": "Aucun résultat trouvé",
          "sEmptyTable": "Aucune donnée disponible",
          "sInfo": "",
          "sInfoEmpty": "",
          searchPlaceholder: "Saisir un mot clé",
          "sInfoFiltered": "",
          "sInfoPostFix": "",
          "sSearch": "Rechercher:",
          "sUrl": "",
          "sInfoThousands": ",",
          "sLoadingRecords": "Chargement...",
          "oPaginate": {
            "sFirst": "<i class='flaticon-left-arrow'></i>",
            "sLast": "<i class='flaticon-right-arrow'></i>",
            "sNext": "<i class='flaticon-arrow-right'></i>",
            "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
          },
          "oAria": {
            "sSortAscending": ": Trier par ordre croissant",
            "sSortDescending": ": Trier par ordre décroissant"
          }
        },
        drawCallback: function () {
          (<any>$('.sparkline')).sparkline([5, 6, 7, 9, 9, 5, 3, 2, 2, 4, 6, 7], {
            type: 'line',
            width: '60',
            height: '20',
            lineColor: '#1a73e9',
            fillColor: '#c2d5ff',
            spotColor: 'transparent',
            minSpotColor: 'transparent',
            maxSpotColor: 'transparent',
            highlightSpotColor: 'transparent',
            highlightLineColor: 'transparent',
          });
        }
      });
    }, 1000);
  }
}
